import { EditParent } from "./Edit";

export const ViewParent = () => EditParent({ editingDisabled: true });
